import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { AuthModule } from '~app/app/auth/auth.module';
import { AuthFacade } from '~app/app/~store/facades/auth.facade';

@Component({
  selector: 'sign-in',
  standalone: true,
  imports: [AuthModule],
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignInComponent implements OnDestroy {
  constructor(private authFacade: AuthFacade) {}

  ngOnDestroy(): void {
    this.authFacade.resetLoginState();
  }
}
